import type { ReactNode } from "react";

type SectionHeaderProps = {
  eyebrow: string;
  eyebrowIcon?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
};

export default function SectionHeader({ eyebrow, eyebrowIcon = "ri-fire-line", title, desc, action }: SectionHeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-100/60 px-3 py-1 text-xs font-medium text-primary-800">
          <i className={eyebrowIcon} />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-[38px] md:leading-tight">{title}</h2>
        {desc && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">{desc}</p>}
      </div>
      {action && <div className="shrink-0 pb-1">{action}</div>}
    </div>
  );
}